import { camelize, capitalize } from '@ember/string';
const DEFAULT_TRUSTEDLIST = ['font', 'font-family', 'font-style', 'font-variant', 'font-size', 'font-weight', 'letter-spacing', 'line-height', 'text-align', 'text-decoration', 'text-indent', 'text-overflow', 'text-shadow', 'text-transform', 'white-space', 'word-spacing', 'word-wrap', 'vertical-align', 'color', 'background', 'background-color', 'background-image', 'background-position', 'background-position-x', 'background-position-y', 'background-repeat', 'background-repeat-x', 'background-repeat-y', 'background-size', 'border', 'border-bottom', 'border-bottom-color', 'border-bottom-left-radius', 'border-bottom-right-radius', 'border-bottom-style', 'border-bottom-width', 'border-collapse', 'border-color', 'border-image', 'border-image-outset', 'border-image-repeat', 'border-image-slice', 'border-image-source', 'border-image-width', 'border-left', 'border-left-color', 'border-left-style', 'border-left-width', 'border-radius', 'border-right', 'border-right-color', 'border-right-style', 'border-right-width', 'border-style', 'border-top', 'border-top-color', 'border-top-right-radius', 'border-top-left-radius', 'border-top-style', 'border-top-width', 'border-width', 'margin', 'margin-left', 'margin-right', 'margin-bottom', 'margin-top', 'padding', 'padding-left', 'padding-right', 'padding-bottom', 'padding-top', 'max-width', 'max-height', 'min-width', 'min-height', 'bottom', 'clear', 'clip', 'cursor', 'display', 'float', 'opacity', 'outline', 'outline-color', 'outline-offset', 'outline-style', 'outline-width', 'overflow', 'overflow-wrap', 'overflow-x', 'overflow-y', 'position', 'resize', 'right', 'top', 'visibility', 'z-index', 'list-style', 'list-style-image', 'list-style-position', 'list-style-type', 'border-collapse', 'border-spacing', 'caption-side', 'empty-cells', 'table-layout', 'box-sizing'];
function CssSlurper(options) {
  this.defaultTrustedlist = options.defaultTrustedlist || DEFAULT_TRUSTEDLIST;
  this.blocklist = options.blocklist || [];
  this.trustedlist = this._mergeTrustedlist(options.trustedlist || []);
}
CssSlurper.prototype = {
  getStyles(element) {
    let styles = '';
    let cssRules = window.getComputedStyle(element);
    for (let i = 0, length = this.trustedlist.length; i < length; i++) {
      let rule = '';
      let property = this.trustedlist[i];
      let camelizedProperty = this._camelize(property);
      let propertyValue = cssRules[camelizedProperty];
      if (propertyValue && propertyValue.length) {
        rule = this._generateRule(element, property, propertyValue);
      }
      styles += rule;
    }
    return styles;
  },
  _camelize(property) {
    let camelized = camelize(property);
    return /^webkit|ms|moz/.test(camelized) ? capitalize(camelized) : camelized;
  },
  _generateRule(element, property, propertyValue) {
    return `${property}: ${propertyValue};`;
  },
  _mergeTrustedlist(customTrustedlist) {
    let self = this;
    customTrustedlist = customTrustedlist.filter(function (property) {
      return self.blocklist.indexOf(property) === -1 && self.defaultTrustedlist.indexOf(property) === -1;
    });
    if (customTrustedlist.length) {
      return self.defaultTrustedlist.concat(customTrustedlist);
    }
    return self.defaultTrustedlist;
  }
};
export default CssSlurper;